import { useState, useEffect } from "react";
import dashboardCardIcon from "../assets/icon/dailywholesale_dash.png";
import { API_URL } from "../utils/constant";
import axios from "axios";
import useGetPermission from "../hooks/useGetPermission";
import AccessDeniedPage from "./AccessDeniedPage";
import { formatReceiptCurrency } from "../utils/format-number";

export function Dashboard() {
  const { hasModuleAccess } = useGetPermission();
  const [dashboard, setDashboard] = useState();

  useEffect(() => {
    axios
      .get(API_URL + "/dashboard/dashboard", {
        withCredentials: true,
      })
      .then((response) => {
        setDashboard(response.data.data);
      });
  }, []);

  const renderAmountPair = (mmkValue, thbValue) => (
    <>
      <p className="amount">{formatReceiptCurrency(mmkValue, "MMK")} MMK</p>
      <p className="amount">{formatReceiptCurrency(thbValue, "THB")} THB</p>
    </>
  );

  return (
    <div className="home-layout" style={{ height: "auto" }}>
      <h1 className="title">Dashboard</h1>

      {hasModuleAccess("Dashboard", "view") ? (
        <>
          <div className="amount-stats-container">
            <div className="box">
              <img src={dashboardCardIcon} className="icon" />
              <h4 className="label">Daily Wholesale</h4>
              {renderAmountPair(
                dashboard?.dailyWholesaleMmk,
                dashboard?.dailyWholesaleThb
              )}
            </div>
            <div className="box">
              <img src={dashboardCardIcon} className="icon" />
              <h4 className="label">Daily Retailsale</h4>
              {renderAmountPair(
                dashboard?.dailyRetailsaleMmk,
                dashboard?.dailyRetailsaleThb
              )}
            </div>
            <div className="box">
              <img src={dashboardCardIcon} className="icon" />
              <h4 className="label">Total Office Users</h4>
              <p className="amount">{dashboard?.totalOfficeUser || 0}</p>
            </div>
          </div>

          <div className="amount-stats-container">
            <div className="box">
              <img src={dashboardCardIcon} className="icon" />
              <h4 className="label">Total Wholesales Customers</h4>
              <p className="amount">{dashboard?.totalWholesaleCustomer || 0}</p>
            </div>
            <div className="box">
              <img src={dashboardCardIcon} className="icon" />
              <h4 className="label">Total Retail Customers</h4>
              <p className="amount">{dashboard?.totalRetailCustomer || 0}</p>
            </div>
            <div className="box">
              <img src={dashboardCardIcon} className="icon" />
              <h4 className="label">Total Member Cards</h4>
              <p className="amount">{dashboard?.totalMemberCard || 0}</p>
            </div>
          </div>

          <div className="amount-stats-container">
            <div className="box">
              <img src={dashboardCardIcon} className="icon" />
              <h4 className="label">Total Product</h4>
              <p className="amount">{dashboard?.totalProduct || 0}</p>
            </div>
          </div>

          <h3 className="table-title">Top Selling Items</h3>

          <div className="table-container">
            <table className="x-table">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Barcode</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {dashboard?.topSellingItems?.map((product, index) => (
                  <tr key={`${product.product_id || product.barcode || index}`}>
                    <td>{product.product_name}</td>
                    <td>{product.barcode}</td>
                    <td>{product.total_qty}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <AccessDeniedPage />
      )}
    </div>
  );
}
